import { Box, Button, Checkbox, Flex, Heading, Icon, Table, Thead, Tr, Th, Td, Tbody, Text, Divider, Switch, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiUser2Fill, RiPencilLine } from "react-icons/ri";
import apiAdonis from '../../../Services/adonis';
import { Dialog, InputGroup, MenuItem } from '@blueprintjs/core';
import { MultiSelect } from '@blueprintjs/select';

interface User {
    id?: number,
    username: string,
    email: string,
    status_user: boolean,
    password?: string,
    permissoes?: Array<Permissao>
}
interface Permissao {
    emp: {
        cd_emp: number,
        name: string
    },
    cc: {
        cd_cc: number,
        name: string
    }
}
interface ComponentProps {
    user: User,
    handleSetUsers(newUser: User, type: "push" | "update"): void,
    getPermissoes: Permissao[]
}

export default function UserList(props: ComponentProps) {
    const toast = useToast();
    const PickerMultiSelectPermissao = MultiSelect.ofType<Permissao>();
    const [getExibirPermissoes, setExibirPermissoes] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [getNovaPermissao, setNovaPermissao] = useState<Permissao>({} as Permissao);
    useEffect(() => {
        async function componentDidMount() {
            // await apiAdonis.get(`/usuarios?cd_emp=${sign_in?.user.cd_emp}`).then(result => setUsers(result.data))
            // await apiAdonis.get(`/biCc?cd_emp=${sign_in?.user.cd_emp}`).then(result => setPermissoes(result.data))
        }
        componentDidMount();
    }, [])
    function Notification(title: string, description: string, status: "success" | "info" | "warning" | "error", duration: number) {
        toast({
            title: title,
            description: description,
            status: status,
            duration: duration,
            isClosable: true,
            position: "top"
        })
    }
    const update_user = async (newUser: User) => {
        setLoading(true)
        await apiAdonis.put('/usuarios/atualizar', newUser);
        setLoading(false)
    }
    return (
        <Tr>
            <Td px="6">
                <Icon color="gray.600" as={RiUser2Fill} />
            </Td>
            <Td>
                <Box>
                    <Text fontWeight="bold">{props.user.username}</Text>
                    <Text fontSize="sm" color="blue.600">{props.user.email}</Text>
                </Box>
            </Td>
            {/* <Td>
                <Switch style={{display:"flex", alignItems:"center", justifyContent:"center"}} isChecked={props.user.status_user} onChange={async () => {
                    props.user.status_user = !(props.user.status_user);
                    props.handleSetUsers(props.user, "update");
                    await update_user(props.user);
                }} />
            </Td> */}
            <Td style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? "none" : "auto" }}>
                {/* <PickerMultiSelectPermissao className="selector" selectedItems={((props.user.permissoes as any).length > 0) ? props.user.permissoes : []} fill={true}
                    popoverProps={{ popoverClassName: "bp3-multi-select-popover", isOpen: getExibirPermissoes, minimal: true, usePortal: true, targetProps: { onClick: () => setExibirPermissoes(true), onBlur: () => setExibirPermissoes(false) } }} items={props.getPermissoes.filter(permissao => !(props.user.permissoes as any).find((item: any) => item.cc.cd_cc === permissao.cc.cd_cc))} onItemSelect={() => { }} noResults={<MenuItem style={{ position: "relative", zIndex: 20000 }} text="Sem resultados disponíveis" />}
                    tagRenderer={(Item) => Item.cc.name} placeholder="Sem permissões"
                    tagInputProps={{
                        onRemove: async (Tag: any, Index: number) => {
                            let newUser = { ...props.user };

                            let Item = (newUser.permissoes as any).find((_Item: any) => _Item.cc.name == Tag);
                            if (Item) {
                                (newUser.permissoes as any).splice((newUser.permissoes as any).findIndex((_Item: any) => JSON.stringify(_Item) == JSON.stringify(Item)) ?? 0, 1);
                                props.handleSetUsers(newUser, "update");
                                await update_user(newUser);
                            }
                        }
                    }}
                    itemRenderer={(Item: Permissao) => <MenuItem style={{ whiteSpace: 'normal' }} active={false} key={Item.cc.name + Item.emp.name} text={Item.cc.name}
                        icon={"circle"}
                        onClick={() => { console.log("HELLO!!!") }}
                    // onClickCapture={async () => {
                    //     console.log("HELLO!!!")
                    //     // let newUser = { ...props.user };
                    //     // (newUser.permissoes as any).push(Item);
                    //     // props.handleSetUsers(newUser, "update");
                    //     // await update_user(newUser);
                    // }}
                    >
                    </MenuItem>}>
                </PickerMultiSelectPermissao> */}

                <PickerMultiSelectPermissao selectedItems={((props.user.permissoes as any).length > 0) ? props.user.permissoes : []} popoverProps={{ usePortal: false, popoverClassName: "bp3-multi-select-popover", minimal: true }} items={props.getPermissoes.filter(permissao => !(props.user.permissoes as any).find((item: any) => item.cc.cd_cc === permissao.cc.cd_cc))} onItemSelect={() => { }} noResults={<MenuItem disabled={true} text="Sem resultados disponíveis" />}
                    fill={true} tagRenderer={(Item) => Item.cc.name} placeholder="Permissões"
                    tagInputProps={{
                        onRemove: async (Tag: React.ReactNode, index: number) => {
                            let newUser = { ...props.user };

                            let Item = (newUser.permissoes as any).find((_Item: any) => _Item.cc.name == Tag);
                            if (Item) {
                                (newUser.permissoes as any).splice((newUser.permissoes as any).findIndex((_Item: any) => JSON.stringify(_Item) == JSON.stringify(Item)) ?? 0, 1);
                                props.handleSetUsers(newUser, "update");
                                await update_user(newUser);
                            }
                        }
                    }}
                    itemRenderer={(Item: Permissao) => <MenuItem style={{ whiteSpace: 'normal' }} active={false} onClick={async () => {
                        let newUser = { ...props.user };
                        (newUser.permissoes as any).push(Item);
                        props.handleSetUsers(newUser, "update");
                        await update_user(newUser);
                    }} text={Item.cc.name} />} itemPredicate={(Texto: string, Item: Permissao) => { return (Item.cc.name ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                </PickerMultiSelectPermissao>
            </Td>
        </Tr>
    )
}